import { Component, Vue, Prop } from 'vue-property-decorator'
import { IMatchup, IPick } from '@/store/modules/game/interfaces'
import { IDraft, IDraftPick } from '@/store/modules/draft/interfaces'
import StatsService from '@/services/StatsService'
import _ from 'lodash'
import { FormatDate, Multipliers, FormatCurrency, StatusFormat, GetWinningPicks } from '@/utils/GameUtils'
import { VNode } from 'vue'

@Component
export default class Draft extends Vue {
  private drafts: IDraft[] = []
  private nextPointer: string | undefined = '0'

  private getSource() {
    this.$store.dispatch('SET_LOADINGSTATE', true)
    this.$store.dispatch('GET_DRAFTS', this.nextPointer).then( draftList => {

      if (!draftList.all) {
        this.$store.dispatch('SET_LOADINGSTATE', false)
        return [] as IDraft[]
      }
      
      let chunk = draftList.all[0].id
      if (this.nextPointer === '0') {
        chunk = '0'
      }

      this.nextPointer = draftList.nextSeq
      this.drafts = this.drafts.concat(draftList.all.map( (dr: IDraft) => {
        dr.chunk = chunk
        return dr
      }) as IDraft[])
      this.$store.dispatch('SET_LOADINGSTATE', false)
    })
  }

  private created() {
    this.getSource()
  }

  private mounted() {
    document.querySelector('.draft-list')?.addEventListener('scroll', () => {
      if (this.$store.getters.LOADING) { return }

      if (this.bottomVisible()) {
        if (this.nextPointer) {
          this.getSource()
        }
      }
    })
  }
  
  private getPayout(draft: IDraft) {
    if (!draft.json.picks) { return 'Checking...'; }

    const multiplyer = Multipliers()[draft.json.picks.length - 1];
    return (draft.json.fee * multiplyer).toFixed(2);
  }
  
  private showDraft(draft: IDraft) {
    // @ts-ignore
    heap.track('history:view:detail', {'ticket': draft.id})

    this.$router.push({ 
      path: `/draft/${draft.chunk}/${draft.id}`,
      params: {
        draft: 'test'
      }
    }) 
  }

  private isClassic(draft: IDraft) {
    //return draft.picks[0].matchup.pickA.player.aspect.id.startsWith('Z')

    if (!draft.json.picks) {
      return 'Mixed'
    }

    const pluck = draft.json.picks.map( p => {
      return p.matchup.pickA.player.aspect.id.toLowerCase().startsWith('z')
    })

    // classic mus
    if (pluck.every( c => c )) return 'Classic'
    // not classics
    if (pluck.every( c => !c )) return 'Daily'
    // must be mixed after checking both
    return 'Mixed'
  }

  // 25-03-20 hopefully can remove soon after a backend fix for classic mode
  private winningsFilter(draft: IDraft): number {
    if (StatusFormat(draft.json.status).toLowerCase() === 'won') {
      return draft.json.winnings
    }
    return 0
  }

  private bottomVisible(leading: number = 0) {
    const target = document.querySelector('.draft-list')

    const scrollY = target?.scrollTop || 0
    const visible = target?.clientHeight || 0
    const pageHeight = target?.scrollHeight || 0
    const bottomOfPage = (visible + scrollY + leading) >= pageHeight
    return bottomOfPage || pageHeight < visible
  }

  private render(h: any): any {
    let drafts: JSX.Element[]

    drafts = this.drafts.map( (draft: IDraft, idx:number) => {
      const mode = this.isClassic(draft)
      const label = mode.toLowerCase()

      return (
        <tbody>
          <tr class='qp-drafts-data-row view-detail' onClick={this.showDraft.bind(this, draft)}>
            <td>{FormatDate(draft.placetime)}</td>
            <td>{StatusFormat(draft.json.status)}</td>
            <td>{draft.json.picks.length}</td>
            <td class='last'>{FormatCurrency(draft.json.fee)}</td>
            <td>{FormatCurrency(this.winningsFilter(draft))}</td>
          </tr>
          <tr>
            <td class={`details-row ${idx === this.drafts.length - 1 ? 'last' : 'row'} ${label} `} colspan='6' onClick={this.showDraft.bind(this, draft)}>
              {mode} Ticket &gt;
            </td>
          </tr>
        </tbody>
      )
    })

    if (this.$store.getters.LOADING && this.nextPointer ==='0') {
      drafts = [(<tr><td class='empty-row' colspan='6'>Loading...</td></tr>)]
    }

    if (this.$store.getters.LOADING && this.nextPointer !== undefined && this.nextPointer !== '0') {
      drafts.push((<tr><td class='empty-row loader' colspan='6'>Loading...</td></tr>))
    }

    if (!this.$store.getters.LOADING && drafts.length < 1) {
      drafts = [(<tr><td class='empty-row' colspan='6'>You don't have any tickets</td></tr>)]
    }

    return (
      <div class='draft-list'>
        <table class='qp-drafts'>
          <tr class='qp-drafts-header-row'>
            <th>Placed</th>
            <th>Status</th>
            <th>Picks</th>
            <th>Fee</th>
            <th>Winnings</th>
          </tr>
          {drafts}
          
        </table>
      </div>
      
    );
  }
}
